import Model  from '@/util/models';

export default class Gedung extends Model { 
    backend = '/master/gedung/';         
    
    tingkats(params = {}){
        return this.api.get(this.backend + 'tingkats', params).then(res => {          
            return res.status == 200 ? res.data : [];
        });
    }
    
    gedungs(params = {}){
        return this.api.get(this.backend + 'gedungs', params).then(res => {          
            return res.status == 200 ? res.data : [];
        });
    }
    
    gedung(params = {}){
        return this.api.get(this.backend + 'gedung', params).then(res => {          
            return res.status == 200 ? res.data : {};
        });
    }
    
    save(body){
        return this.api.post(this.backend + 'save', body);
    }

    pindahRuangan(body){
        return this.api.post(this.backend + 'pindah-ruangan', body);
    }
}

